<template>
    <div class="video-component">
        <b-modal
            id="video-modal"
            ref="video-modal"
            centered
            size="lg"
            body-class="pl-1 pr-1 pt-1 pb-1"
            hide-footer
            content-class = "bg-transparent"
            header-class="pl-0 pr-0 pb-0 border-0"
            header-bg-variant="transparent"
            body-bg-variant="danger"
            @hidden="hiddenModal"
            >
            <template v-slot:modal-header="{ close }">
                <b-button-group class="container pl-0 pr-0" size="lg">
                <!-- Emulate built in modal header close button action -->
                <b-button class="pb-1 pr-0" size="lg" @click="close()" variant="transparent">
                    <b-icon class="float-right pr-0" font-scale="1.5" icon="x-circle" variant="danger"></b-icon>
                </b-button>
                </b-button-group>
            </template>
            <b-embed
                type="iframe"
                aspect="16by9"
                :src="url"
                allowfullscreen
            ></b-embed>
        </b-modal>
    </div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
    name: 'Video',
    components: {
    },
    props: {
        url: { type: String, default: null },
        inFrame: { type: Boolean, default: true },
    },
    data() {
        return {
            videoOptions: {
				autoplay: true,
                controls: true,
                liveui: true,
                fluid: true,
                preload: 'auto',
                class:"video-js",
                lang: 'es',
                aspectRatio: "16:9",
                sources: [
                    {
                        src: this.url,
                        type: 'application/x-mpegURL'
                    }
                ],
                playbackRates: [0.5, 1, 1.5, 2]
            }
        }
    },
    methods: {
        showModal() {
            this.$bvModal.show('video-modal')
        },
        hiddenModal(error) {
            if(error) this.$emit('closed', error)
            else this.$emit('closed')
        },
    },
    computed: {
        assistant: function() {
            return this.$store.getters.assistant
        }
    },
    mounted() {
        this.videoOptions.sources = [
            { src: this.url }
		]
        this.showModal()
        /* this.$gtag.event('streaming', {
            'event_category': 'Streaming',
            'event_label': this.assistant,
        }) */
    },
})
</script>

<style lang="scss" scoped>
</style>
